import type { PlaneOrientation } from "../../viewport/types";

/**
 * Overlay description for a pane, plane-aware.
 *
 * A reformat pane's `seriesId` is the SOURCE series (that is how the shared
 * cached volume is reached), so its metadata description is the source's — e.g.
 * "AXIAL 2.0MM" printed over a coronal image, which is how a reformat came to
 * read as an axial series in the 2026-07-24 review. Leading with the plane makes
 * the pane read as a derived view OF a named series.
 *
 * `plane === null` means this is not a reformat pane; the description passes
 * through untouched.
 */
export function reformatSeriesLabel(
  seriesDescription: string | null,
  plane: PlaneOrientation | null,
): string | null {
  if (!plane) return seriesDescription;
  return seriesDescription ? `${plane} MPR · ${seriesDescription}` : `${plane} MPR`;
}
